/**
 * Merkezi API helper'ları — Iter 110/Faz1.
 * Tüm yan dosyalardaki `const hdrs = () => ({...})` duplikasyonunu sonlandırmak için.
 *
 * Kullanım:
 *   import { API, hdrs } from '../lib/api';
 *   axios.get(`${API}/api/bol/orders`, { headers: hdrs() });
 */
export const API = process.env.REACT_APP_BACKEND_URL;

export const hdrs = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const hdrsJSON = () => ({
    ...hdrs(),
    'Content-Type': 'application/json',
});
